<template>
    <div class="contanner">
        <el-button @click="back" class="back_btn" type="text" icon="el-icon-d-arrow-left
">返回</el-button>
        <slot name="top" :info="info"></slot>
        <div class="base_detail">
            <div class="detail_l">
                <div class="detail_l_cont">
                    <!-- 内容 -->
                    <slot name="cont" :info="info"></slot>
                </div>
                <div class="detail_l_comment" v-if="showCom">
                    <div class="comment_box">
                        <Input
                            type="textarea"
                            :rows="5"
                            placeholder="请文明评论..."
                            v-model="textarea"
                            maxlength="500"
                            show-word-limit
                        />
                        <el-button v-if="readerId" type="primary" class="comment_btn" @click="sendCommentBtn" >评论</el-button>
                        <div class="login_wrp" v-else>
                            <el-button type="warning" class="login_btn" @click="toLogin">登录</el-button>
                            <span>请登录后评论</span>
                        </div>
                    </div>
                    <div class="comment_list">
                        <div class="list_title">
                            <img
                                src="~@/assets/detail/hot.png"
                                alt="热门评论"
                            />
                            热门评论
                        </div>
                        <div class="list_box">
                            <div v-if="commentList.length" class="comment_list_box">
                                <div class="comment_item_box" v-for="item in commentList" :key="item.id">
                                    <div >
                                        <img width="50" height="50" src="~@/assets/detail/dfut_comment.png" />
                                    </div>
                                    <div class="comment_item_r">
                                        <div class="item_box_name">{{item.readerName}}</div>
                                        <div class="comment_content">{{item.info2}}</div>
                                        <div class="comment_time">{{item.createTime}}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="empty">暂无评论，快来抢沙发吧！</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail_r">
                <div class="detail_r_top">
                    <div class="top_row">
                        <img :src="venueInfo.logo"/>
                        <div class="name_tag">
                            <div class="name">{{venueInfo.name}}</div>
                            <div class="tag ellipsis" :title="venueInfo.address">{{venueInfo.address}}</div>
                        </div>
                    </div>
                    <div class="desc ellipsis_3" :title="venueInfo.description">
                    {{venueInfo.description}}
                    </div>
                </div>
                <slot name="recom">
                    <!-- 暂时隐藏 -->
                    <div class="recommend_wrap" v-if="false">
                        <div class="recommend_title">
                            <span class="title_icon">精</span>
                            <span>精彩推荐</span>
                        </div>
                        <div class="recommend_list">
                            <div class="recommend_item">
                                <img
                                    class="item_img"
                                    src="https://www.ynggwhy.cn/file/hbY3dGDs5jDBxn6RTX/2020-11-12/source/f5c6c04073444210bc71db0d96cdfd87.jpeg"
                                    alt=""
                                />
                                <div class="item_info">
                                    <div class="title ellipsis">
                                        穿越千年的人间烟火—被国家博物馆收藏！这组来自德宏芒市寨子的摄影作品长啥样？
                                    </div>
                                    <div class="bot">
                                        <span style="margin-right: auto"
                                            >浏览 {{ 1 }}</span
                                        >
                                        <svg-icon
                                            icon-class="comment"
                                            class-name="card-panel-icon"
                                        />
                                        <span style="margin-right: 7px">{{
                                            1
                                        }}</span>
                                        <svg-icon
                                            icon-class="thumb"
                                            class-name="card-panel-icon"
                                        />
                                        <span>{{ 1 }}</span>
                                    </div>
                                    <div class="item_footer">
                                        <img
                                            class="item_footer_icon"
                                            src="https://www.ynggwhy.cn/file/hbY3dGDs5jDBxn6RTX/2020-06-01/source/9b388f9766b64b4cbf7dabe8c27852ac.png"
                                        />
                                        <span style="margin-right: auto"
                                            >畹町文化馆</span
                                        >
                                        <span>11-11</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
import { Input } from 'element-ui';
import { post, get } from '@u/request'
import { getActivityStatus } from '@u/index'
import { mapGetters } from 'vuex';

export default {
    name: '',
    components: {
        Input
    },
    props: {
        showCom: {
            type: Boolean,
            default: true
        },
    },
    data () {
        return {
            textarea: '',
            info: {
            },
            venueInfo: {},
            commentList: []
        }
    },
    computed: {
        ...mapGetters([
            'readerId',
        ]),
        contentId() {
            return this.$route.params.id
        }
    },
    methods: {
        back() {
            this.$router.back();
        },
       toLogin() {
           this.$store.commit('SET_VISIBLE_LOGIN',true);
       },
        async sendCommentBtn() {
            if (!this.textarea) return;
         
            const params = {
                [this.url]: this.contentId,
                info2: this.textarea,
                readerId: this.readerId
            }
            const { code } = await post('resource/comment/add',params);
            if (code == 0) {
                // 暂时 push, 后续刷新 评论列表
                this.$message.success('评论成功，请等待审核！')
                this.textarea = '';
            }
        },
        async videoLoad(url) {
            const loading = this.$loading('base_detail')
            const {data} = await get(`resource/${url}/get/${this.contentId}`).catch(()=> loading.close());
            loading.close()
            if (data.endTime) {
                const status = getActivityStatus(data.endTime);
                data.activityStatus = status;
                data.statusName = status ? '我要报名' : '已结束'
            }
            this.info = data;
            this.getVenueInfo();
        },
        async getVenueInfo() {
			if(!this.info.venueId) return;
            const { data } = await get(`resource/venue/get/${this.info.venueId}`);
            this.venueInfo = data;
            this.info.venueName = data.name;
        },
        async loadCommentList(url) {
            this.url = url;
            const { data } = await post('resource/comment/list',{[url]: this.contentId})
            this.commentList = data;
        }
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
.back_btn {
    font-size: 22px;
    color: #666;
}
.base_detail {
    padding: 0px 0 45px 0px;
    display: flex;
    justify-content: space-between;
    .detail_l {
        width: 845px;
        border-radius: 5px;
    }
    .detail_l_cont {
        background: #fff;
        box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.05);
    }
    .detail_l_comment {
        margin-top: 20px;
        background: #fff;
        padding: 40px 30px 20px;
        box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.05);
        border-radius: 5px;
        ::v-deep {
            .el-textarea__inner {
                background: #f2f2f2;
                color: #999;
                padding: 15px;
                border: none;
            }
            .el-input__count {
                background: #f2f2f2;
                right: 90px;
                bottom: 20px;
            }
        }
        .comment_box {
            position: relative;
            margin-bottom: 60px;
        }
        .comment_btn {
            position: absolute;
            bottom: 10px;
            right: 10px;
        }
        .login_wrp {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: bold;
        }
        .login_btn {
            font-size: 16px;
            margin-right: 16px;
        }
        .comment_list {
            .list_title {
                display: flex;
                align-items: center;
                color: #000;
                font-weight: bold;
                font-size: 24px;
                > img {
                    margin-right: 6px;
                }
            }
            .list_box {
                padding: 20px 36px 0;
            }
            .empty {
                text-align: center;
                padding: 30px;
                color: rgb(119, 119, 119);
                font-size: 16px;
            }
        }
    }
    .detail_r {
        width: 335px;
    }
    .detail_r_top {
        height: 179px;
        padding: 20px 18px;
        background: #fff;
        box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.05);
        border-radius: 5px;
        .top_row {
            display: flex;
            > img {
                width: 62px;
                height: 62px;
                margin-right: 16px;
            }
			> .name_tag{
				overflow: hidden;
				.name {
					font-size: 20px;
					color: #000;
				}
				.tag {
					width: 100%;
					//height: 20px;
					margin-top: 11px;
					line-height: 20px;
					//text-align: center;
					font-size: 14px;
					border-radius: 5px;
					cursor: pointer;
				}
			}
        }
        .desc {
            font-size: 14px;
            line-height: 24px;
            color: #777;
            margin-top: 10px;
        }
    }
    .recommend_wrap {
        margin-top: 20px;
        box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.05);
        border-radius: 5px;
        .recommend_title {
            padding: 28px 0 28px 17px;
            font-size: 24px;
            font-weight: 800;
            border-radius: 5px 5px 0 0;
            background: #fff;
            .title_icon {
                display: inline-block;
                width: 27px;
                height: 27px;
                color: #fff;
                background-color: #ff9c00;
                border-radius: 5px;
                font-size: 18px;
                font-weight: 400;
                text-align: center;
                line-height: 27px;
                margin-right: 7px;
            }
        }
        .recommend_item {
            border-radius: 5px;
            border-bottom: 1px solid #e5e5e5;
            background: #fff;
            overflow: hidden;
            margin-bottom: 18px;
            .item_img {
                width: 100%;
                height: 155px;
                object-fit: cover;
            }
            .item_info {
                padding: 18px;
                .title {
                    font-size: 18px;
                    font-weight: 400;
                    color: #000;
                }
                .bot {
                    display: flex;
                    align-items: center;
                    color: #c0c0c0;
                    margin: 15px 0 25px;
                }
                .item_footer {
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    color: #777;
                }
                .item_footer_icon {
                    width: 32px;
                    height: 32px;
                    margin-right: 7px;
                    overflow: hidden;
                    border-radius: 50%;
                }
                .card-panel-icon {
                    font-size: 16px;
                    margin-right: 7px;
                }
            }
        }
    }
    .comment_list_box {
        padding: 20px 0;
    }
    .comment_item_box {
        display: flex;
        margin-bottom: 16px;
        .comment_item_r {
            flex: 1;
            margin-left: 10px;
            font-size: 16px;
        }
        .item_box_name {
            color: #777;
            margin-bottom: 10px;
        }
        .comment_content {
            margin-bottom: 10px;
        }
        .comment_time {
            font-size: 14px;
            color: #777;
        }
    }
}
</style>